import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import Header from "../component/sharedComponents/header";
import FooterUser from "../component/sharedComponents/footer";
import CopyLink from "../component/iFrame/copyLink";
import ShoppingBrandsWebsites from "../component/chooseShopping/shoppingBrandsWebsites";

const ChooseShoppingTrukeyPage = () => {
  const location = useLocation();
  const { id } = useParams();

  // Optional effect to log or verify state updates
  useEffect(() => {
    if (!location.state?.websites) {
      console.error("No websites found in state.");
    }
  }, [location.state]);
  return (
    <div key={id} className="flex flex-col justify-between min-h-screen">
      <Header />
      <div className="mt-[55px] md:mt-[54px] lg:mt-[75px]">
        <CopyLink />
        <ShoppingBrandsWebsites />
      </div>
      <FooterUser />
    </div>
  );
};

export default ChooseShoppingTrukeyPage;
